import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(n: number): string {
  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + 'G';
  if (n >= 1_000_000)     return (n / 1_000_000).toFixed(1) + 'M';
  if (n >= 1_000)         return (n / 1_000).toFixed(1) + 'k';
  return Math.floor(n).toLocaleString('de-CH');
}

const TICK_SEC = 300

export function formatTicks(seconds: number): string {
  if (seconds <= 0) return '0 Ticks'
  const ticks = Math.round((seconds / TICK_SEC) * 10) / 10
  const label = ticks === 1 ? 'Tick' : 'Ticks'
  return Number.isInteger(ticks) ? `${ticks} ${label}` : `${ticks.toFixed(1)} ${label}`
}

export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${m.toString().padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${s.toString().padStart(2, '0')}s`;
  return `${s}s`;
}

export function formatCoords(g: number, s: number, p: number): string {
  return `[${g}:${s}:${p}]`;
}
